/* eslint-disable no-prototype-builtins */

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import TextField from '@mui/material/TextField'
import IconButton from '@mui/material/IconButton'
import Button from '@mui/material/Button'
import Modal from '@mui/material/Modal'

import FAQ from '../../../homepage/FAQ'

import { reviewTypeOptionsArray, positionChangeWidthSm } from '../../../../helpers/variableDefaults'
import { standardInfoTooltip } from '../../../../helpers/tooltips'

export const selectReviewTypeJSX = (selectedReviewType, handleSelectReviewType, width) => {

  return (
    <Box
      sx={{
        my: 1,
        p: 2,
        backgroundColor: 'whitesmoke',
        width: '95%',
        boxShadow: 3,
        borderRadius: '5px',
        display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center',
      }}
    >
      {/* Title, Advisory */}
      <Box
        sx={{
          mb: 1,
          display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center',
        }}
      >
        <Typography
          sx={{
            mb: 0,
            fontWeight: 'bold',
            fontSize: '20px',
          }}
        >
          Review Type
        </Typography>
      </Box>

      {/* Review Type Summary (AI, Friend, or Expert, Price) */}
      <Box
        sx={{
          my: 1,
          // p: 2,
          width: '95%',
          // backgroundColor: 'white',
          // borderRadius: 3,
          // border: 2,
          // borderColor: 'black',
          display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center',
        }}
      >
        {reviewTypeOptionsArray.map((reviewTypeItem, reviewTypeItemIndex) => (
          <Box
            key={reviewTypeItemIndex}
            sx={{
              mx: width < positionChangeWidthSm ? 1 : 2,
              px: 0,
              width: width < 350 ? '30%' : '100px',
              display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center',
            }}
          >
            <Box
              // key={reviewTypeItemIndex}
              onClick={(e) => handleSelectReviewType(e, reviewTypeItem)}
              sx={{
                mx: width < positionChangeWidthSm ? 1 : 2, mb: 1,
                p: 2,
                backgroundColor: 'white',
                borderRadius: 3,
                border: 2,
                borderColor: selectedReviewType.type === reviewTypeItem.type ? 'blue' : 'black',
                cursor: 'pointer',
                width: width < 350 ? '30%' : '100px',
                display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center',
              }}
            >
              <Typography
                sx={{
                  fontWeight: 'bold',
                  fontSize: '16px',
                }}
              >
                {`${reviewTypeItem.type}`}
              </Typography>
              
              <Typography
                sx={{
                  mt: 1,
                  // minHeight: '30px',
                  fontWeight: 'bold',
                  fontSize: '16px',
                  color: 'gray',
                  textDecoration: 'line-through',
                }}
              >
                {/* {reviewTypeItem.type === 'Expert' ? 'Impossible' : `$${reviewTypeItem.fullPrice}`} */}
                {reviewTypeItem.type === 'Expert' ? `$${reviewTypeItem.fullPrice}` : `$${reviewTypeItem.fullPrice}`}
              </Typography>

              <Typography
                sx={{
                  mt: 1,
                  fontWeight: 'bold',
                  fontSize: '16px',
                  color: reviewTypeItem.price === 0 ? 'blue' : reviewTypeItem.type === `Expert` ? 'black' : '',
                }}
              >
                {/* {reviewTypeItem.price === 0 ? `FREE` : reviewTypeItem.type === `Expert` ? `Best` : `$${reviewTypeItem.price}`} */}
                {reviewTypeItem.price === 0 ? `FREE` : reviewTypeItem.type === `Expert` ? `$${reviewTypeItem.price}` : `$${reviewTypeItem.price}`}
              </Typography>

              {/* <Typography
                sx={{
                  mt: 1,
                  fontWeight: 'bold',
                  fontSize: '16px',
                }}
              >
                {`${reviewTypeItem.duration}`}
              </Typography> */}

            </Box>

            {standardInfoTooltip(reviewTypeItem.tooltip)}
          </Box>
        ))}
      </Box>

      {/* FAQ */}
      <Box
        sx={{
          my: 1,
          // p: 2,
          width: '95%',
          // maxWidth: '400px',
          display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center',
        }}
      >
        <FAQ fromComponent={`requestReview`} />
      </Box>

    </Box>
  )
}